var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.17065 6.5H11.1707",
    stroke: "#6C6C6C",
    strokeWidth: 1.17748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2745 6.80005V9.68005C10.2745 9.871 10.1639 10.0541 9.96697 10.1892C9.77006 10.3242 9.50299 10.4 9.22451 10.4H2.92451C2.64603 10.4 2.37896 10.3242 2.18205 10.1892C1.98514 10.0541 1.87451 9.871 1.87451 9.68005V6.80005",
    stroke: "#6C6C6C",
    strokeWidth: 1.17748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1709 4.5L10.1709 2.5",
    stroke: "#6C6C6C",
    strokeWidth: 1.17748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60078 3.89002L4.37578 2.98502C4.34354 2.85764 4.33672 2.72515 4.35572 2.59513C4.37471 2.46511 4.41915 2.34011 4.48648 2.22727C4.55381 2.11443 4.64272 2.01597 4.74812 1.93751C4.85353 1.85906 4.97336 1.80214 5.10078 1.77002L6.07078 1.53002C6.1985 1.49786 6.33131 1.49125 6.46159 1.51057C6.59187 1.52988 6.71706 1.57474 6.82995 1.64257C6.94285 1.7104 7.04123 1.79987 7.11946 1.90583C7.19768 2.01179 7.2542 2.13216 7.28578 2.26002L7.51078 3.16002",
    stroke: "#6C6C6C",
    strokeWidth: 1.17748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.170898 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepTime);
export default __webpack_public_path__ + "static/media/prepTime.115050c71c7c27199b9b3a7372ac23ff.svg";
export { ForwardRef as ReactComponent };